import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { DIVISIONS } from "../data/site";

export default function DivisionCards() {
  return (
    <div className="grid gap-px border border-gold/15 bg-gold/15 lg:grid-cols-6" data-testid="division-cards">
      {DIVISIONS.map((d, i) => {
        const comingSoon = d.letter === "D" || d.letter === "E";
        return (
          <Reveal key={d.slug} className={`h-full ${i < 2 ? "lg:col-span-3" : "lg:col-span-2"}`}>
            <Link
              to={comingSoon ? "/quote" : `/${d.slug}`}
              data-testid={d.testId}
              className={`group relative flex h-full flex-col justify-end overflow-hidden bg-ink p-9 sm:p-12 ${
                i < 2 ? "min-h-[420px]" : "min-h-[360px]"
              }`}
            >
              <img
                src={d.image}
                alt={d.alt}
                className="absolute inset-0 h-full w-full object-cover opacity-45 transition-all duration-700 group-hover:scale-105 group-hover:opacity-55"
                style={{ filter: "grayscale(0.4) brightness(0.6) sepia(0.25)", objectPosition: d.imgPos || "center" }}
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/55 to-ink/20" />
              <div className="relative">
                <p className="overline-gold">{`Division ${d.letter}`}</p>
                <h3 className={`mt-4 font-heading leading-tight text-foreground transition-colors duration-300 group-hover:text-gold-light ${i < 2 ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"}`}>
                  {d.title}
                </h3>
                <p className="mt-4 max-w-md text-sm leading-[1.85] text-foreground/70">{d.desc}</p>
                <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.22em] text-gold/80">
                  {d.note || `${d.categories.length} categories`}
                </p>
                <span className="mt-8 inline-flex items-center gap-2 border-t border-gold/25 pt-5 text-[11px] font-semibold uppercase tracking-[0.22em] text-gold transition-colors group-hover:text-gold-light">
                  {comingSoon ? "Coming soon — register interest" : "Explore This Division"}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        );
      })}
    </div>
  );
}

const NEXT_LINKS = [
  ...DIVISIONS.map((d) => ({
    to: `/${d.slug}`,
    label: d.letter === "E" ? `${d.title} — Coming Soon` : d.title,
    testId: `next-${d.testPrefix}`,
  })),
  { to: "/gallery", label: "Our Gallery — Real Operations", testId: "next-gallery" },
];

export function NextPaths({ exclude }) {
  const links = NEXT_LINKS.filter((l) => l.to !== exclude);
  return (
    <section className="border-t border-gold/10 py-20" data-testid="next-paths">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <Reveal>
          <p className="overline-gold">Continue Exploring</p>
        </Reveal>
        <div className="mt-8">
          {links.map((l, i) => (
            <Reveal key={l.to} delay={0.06 * i}>
              <Link
                to={l.to}
                data-testid={l.testId}
                className="group flex items-center justify-between border-b border-gold/15 py-6 transition-colors duration-300 hover:border-gold/40"
              >
                <span className="font-heading text-lg text-foreground transition-colors duration-300 group-hover:text-gold-light sm:text-xl">
                  {l.label}
                </span>
                <ArrowUpRight className="h-5 w-5 text-gold transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
